import { useEffect } from 'react'
import { home } from 'Modules/Analytics/trackActionInterface/Home'

const NAV_RENDERED = 'navigation rendered'
const NAV_ITEMS_RENDERED = 'navigation items rendered'
export const useNavigationPerfAnalytics = ({
  navItemsLoaded,
}: {
  navItemsLoaded: boolean
}) => {
  useEffect(() => {
    try {
      if (performance.getEntriesByName(NAV_RENDERED).length === 0) {
        // Set a mark so that we can use it for measures if we want
        performance.mark(NAV_RENDERED)
        home.Navigation_Load_Tracked({
          loadTime: performance.getEntriesByName(NAV_RENDERED)[0].startTime,
        })
      }
    } catch (e) {
      // Don’t crash anything if performance API doesn’t exist
    }
  }, [])

  useEffect(() => {
    try {
      if (
        navItemsLoaded &&
        performance.getEntriesByName(NAV_ITEMS_RENDERED).length === 0
      ) {
        // Set a mark so that we can use it for measures if we want
        performance.mark(NAV_ITEMS_RENDERED)
        home.Navigation_Items_Load_Tracked({
          loadTime:
            performance.getEntriesByName(NAV_ITEMS_RENDERED)[0].startTime,
        })
      }
    } catch (e) {
      // Don’t crash anything if performance API doesn’t exist
    }
  }, [navItemsLoaded])
}
